<div class="app-container">
  <div >
    <alert></alert>
    <router-outlet></router-outlet>
  </div>
</div>